import { CycleBpModel } from './../../../shared/models/societe-linked/bp/cycle-bp.model';
import { Title } from '@angular/platform-browser';
import { DetailBcLineinfos } from './../../bc/bc-components.service';
import { SocieteService } from './../../../shared/services/simple/societe.service';
import { BpModel } from 'src/app/shared/models/societe-linked/bp/bp.model';
import { DetailBpinfos, DetailBpLineinfos } from './../bp-components.service';
import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { SocieteModel } from 'src/app/shared/models/simple-types/societe.model';
import { BpService } from 'src/app/shared/services/bp/bp.service';
import { StateService } from 'src/app/shared/services/state.service';
import { BpComponentsService } from '../bp-components.service';
import { BcModel } from 'src/app/shared/models/societe-linked/bc/bc.model';
import { List } from 'postcss/lib/list';
import { BcService } from 'src/app/shared/services/bc/bc.service';

@Component({
  selector: 'app-read-bp',
  templateUrl: './read-bp.component.html',
  styleUrls: ['./read-bp.component.scss']
})
export class ReadBpComponent implements OnInit {
  bpForm: UntypedFormGroup;
  bp: BpModel = new BpModel();
  user: string;
  detailBpInfo: DetailBpinfos = new DetailBpinfos();
  DetailBpLineinfos: DetailBpLineinfos = new DetailBpLineinfos();
  bpSociety: SocieteModel = new SocieteModel();
  bpLineHTs = 0;
  bpLineTVAs = 0;
  bpLineTTCs = 0;
  childHeight = 0;
  parentWidth = 0;
  bcs: BcModel[] = [];

    constructor(private bpService: BpService,
                private router: Router,
                private route: ActivatedRoute,
                private bpComponentsService: BpComponentsService,
                private bcSercive: BcService,
                private societeService: SocieteService,
                private toastrService: ToastrService,
                private title: Title) {
                  this.title.setTitle('SACHA - Visualisation BP');

                  this.route.params.subscribe((params: any) => {
                    if (params.id === '0') {
                      this.bpService.bpSubscriber.subscribe((bp: BpModel) => {
                        if (bp !== null) {
                          this.bp = Object.assign({}, bp);
                        } else {
                          this.toastrService.error('Erreur durant la récupération du bon à payer.', 'Erreur');
                          this.router.navigate(['/']);
                        }
                      });
                    } else {
                      this.bpService.get(params.id).subscribe(bp => {
                        this.bp = bp;
                        for (const bpligne of bp.bpLines) {
                          if (bpligne.idBcLigne){
                            this.bcSercive.get(bpligne.bcLigne.idBc).subscribe(bc => {
                              if (!this.bcs.find(b => b.id === bpligne.bcLigne.idBc)) {
                                this.bcs.push(bc);
                              }
                            });
                          }
                        }
                        this.detailBpInfo = new DetailBpinfos();
                        this.DetailBpLineinfos = new DetailBpLineinfos();
                        this.bpForm = this.bpComponentsService.getVisualizeBpFormGroup(this.bp);
                         if (this.bpForm) {
                          this.bpLineTVAs = this.bpForm.get('tva').value;
                          this.bpLineTTCs = this.bpForm.get('ttc').value;
                          this.bpLineHTs = this.bpForm.get('ht').value;          
                        }

                      }, (error) => {
                          toastrService.error('Le bon à payer n\'existe pas');
                          this.router.navigate(['/not-found']);
                      });
                    }
                  });
                }

    ngOnInit(): void {
      this.getChildHeight();
      this.getParentWidth();
    }

    close(): void {
      this.router.navigate(['/list-bp/']);
    }

    print(): void {
      window.open('/assets/pdfs/bcpdf.pdf');
    }

    getSortedArrayByDate(): CycleBpModel[] {
      const arraySorted = this.bp.cycleBps.sort((a: CycleBpModel, b: CycleBpModel) => {
        return +new Date(b.dAction) - +new Date(a.dAction);
      });
      return arraySorted;
    }

    setSociety(society: SocieteModel): void {
      if (society) {
        this.bpSociety = Object.assign({}, society);
        this.bp.societe = this.bpSociety;
      }
    }

    getAndSetSociety(idSociety: number): Observable<SocieteModel> {
      return this.societeService.get(idSociety);
    }

    getChildHeight(): any {
      setTimeout(() => {
        const childHeight = document.querySelector('#cycles')?.clientHeight;
        if (childHeight && childHeight > 0) {
          this.childHeight = childHeight;
        }
      }, 200);
    }

    getParentWidth(): any {
      setTimeout(() => {
        const parentWidth = document.querySelector('#read-bp-container')?.clientWidth;
        if (parentWidth && parentWidth > 0) {
          this.parentWidth = parentWidth;
        }
      }, 200);
    }
}
